/* eslint-disable react/no-unstable-nested-components */
import React from 'react'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
// import { useFetchTransfer } from 'core/hooks/api'

// Styled Elements
import {
  TableButtonWrapper,
  TableRowWrapper,
  TableColWrapper,
  TableRowContainer,
  IconPlaceholder,
} from './TravelRuleTableItemLoading.elements'

// Views
import { AccordionTableItem, ProgressBar, TextLoading } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) => actions(dispatch)

function TravelRuleTableItemLoading() {
  return (
    <AccordionTableItem
      setIsExpanded={() => {}}
      expandPanel={false}
      button={
        <TableButtonWrapper>
          <TableRowWrapper>
            <TableRowContainer style={{ gap: '10px', maxWidth: '80px' }}>
              <IconPlaceholder />
              <TableColWrapper style={{ gap: '5px' }}>
                <TextLoading height={18} width={30} />
                <TextLoading height={10} width={40} />
              </TableColWrapper>
            </TableRowContainer>

            <TableRowContainer>
              <TableColWrapper style={{ gap: '5px' }}>
                <TextLoading height={18} width={95} />
                <TextLoading height={10} width={50} />
              </TableColWrapper>

              <IconPlaceholder style={{ height: '24px', width: '24px', borderRadius: '6px' }} />

              <TableColWrapper style={{ gap: '5px' }}>
                <TextLoading height={18} width={95} />
                <TextLoading height={10} width={50} />
              </TableColWrapper>
            </TableRowContainer>

            <TableRowContainer>
              <TextLoading height={20} width={130} />
            </TableRowContainer>
          </TableRowWrapper>

          <TableRowWrapper>
            <TableRowContainer>
              <TextLoading height={20} width={80} />
              <ProgressBar width={0} maxWidth="280px" />
            </TableRowContainer>

            <TableRowContainer>
              <TableColWrapper style={{ gap: '5px' }}>
                <TextLoading height={17} width={50} />
                <TextLoading height={12} width={30} />
              </TableColWrapper>
            </TableRowContainer>
          </TableRowWrapper>
        </TableButtonWrapper>
      }
      panel={<div />}
    />
  )
}

// Default Props
TravelRuleTableItemLoading.defaultProps = {}

// Proptypes Validation
TravelRuleTableItemLoading.propTypes = {}
export default connect(mapStateToProps, mapDispatchToProps)(TravelRuleTableItemLoading)
